import Container from "@client/content/Containers/container";
import FormStyleProvider from "@client/content/Providers/FormStyle/container";
import { getContainerProps, getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { Alert } from "@client/controls/Alert/component";
import { type WithId, type WithIsEditMode } from "@client/types";
import { initStripe } from "@common/components/Form/Field/StripeCard/lib";
import { SystemColor } from "@common/declarations";
import { usePromise, useUpdated } from "@common/lib/hooks";
import * as React from "react";
import AlertModal from "./AlertModal/container";
import First from "./First/container";
import Second from "./Second/container";
import Third from "./Third/container";

import { useI18n } from "@common/hooks/i18n";
import "./style.less";

export type MapProps = RootContainerProps &
  WithIsEditMode &
  WithId & {
    hasPackage: boolean;
    mode: string;
    packageId: string | null;
    publishableKey: string | null;
    step: number;
    trialId: string | null;
  };

export interface ActionProps {
  init: () => void;
}
export type Props = ActionProps & MapProps;

const Content = ({ step, ...props }: Props) => {
  const i18n = useI18n();

  useUpdated(() => {
    if (props.packageId || props.trialId) {
      props.init();
    }
  }, [props.packageId, props.trialId]);

  // preload stripe
  usePromise({
    fn: initStripe,
    args: [props.publishableKey],
    shouldLoad: !!props.publishableKey,
    reload: props.packageId
  });

  return (
    <FormStyleProvider {...getEntityRef(props)}>
      {props.isEditMode ? (
        props.hasPackage ? (
          <Alert color={SystemColor.Orange}>
            {props.mode.toLowerCase() === "test" ? i18n.infoTestMode : i18n.infoLiveMode} mode
          </Alert>
        ) : (
          <div>{i18n.infoChoosePackage}</div>
        )
      ) : null}

      {step === 1 && <First {...getRootContainerProps(props)} />}
      {step === 2 && <Second {...getRootContainerProps(props)} />}
      {step === 3 && <Third {...getRootContainerProps(props)} />}

      <AlertModal {...getRootContainerProps(props)} />
    </FormStyleProvider>
  );
};

export default (props: Props) => (
  <Container className="cartly_content_purchase" {...getContainerProps(props)}>
    <Content {...props} />
  </Container>
);
